export const SALES_ITEMS_INDIVIDUAL_PROP_FIELDS = Array.from(
  { length: 50 },
  (_, i) => `prop${i + 1}`
);
